import React from 'react';
import PropTypes from 'prop-types';
import cardNoImg from '../../assets/icons/aviso-sin-foto.svg';
import MiniCardSkeleton from './MiniCardSkeleton';
import { Container } from './styles';

const PostingMiniCard = ({ device, posting, isLoading = false }) => {
  const { title, address, isReserved, urlPicture } = posting;
  const realestateType = posting.realestate_type;

  return (
    <Container device={device} hasImage={urlPicture} isLoading={isLoading}>
      {!isLoading ? (
        <>
          <div className='img-container'>
            <div className='img-frame'>
              <img src={urlPicture || cardNoImg} alt='Posting-img' data-panel='imagen' />
            </div>
            {isReserved && (
              <div className='tag-reserved' data-panel='posting-tagReservado'>
                Reservado
              </div>
            )}
          </div>
          <div className='info-container'>
            <div className='realestateType' data-panel='posting-realestateType'>
              {realestateType}
            </div>
            <div className='title' data-panel='posting-title'>
              {title}
            </div>
            <div className='address' data-panel='posting-address'>
              {address}
            </div>
          </div>
        </>
      ) : (
        <MiniCardSkeleton device={device} />
      )}
    </Container>
  );
};

PostingMiniCard.propTypes = {
  device: PropTypes.string.isRequired,
  posting: PropTypes.shape({
    title: PropTypes.string,
    address: PropTypes.string,
    isReserved: PropTypes.bool,
    urlPicture: PropTypes.string,
    realestate_type: PropTypes.string
  }).isRequired
};

export default PostingMiniCard;
